<div id="app-container">
  <block-ui>
    <router-outlet></router-outlet>
  </block-ui>
</div>
<ng-container *ngIf="isFullyBrowser">
  <app-iframe-overlay-container></app-iframe-overlay-container>
</ng-container>
